<template>
  <v-select
    id="presenter_query"
    :options="presenters"
    data-test="presenter_query"
    :value="value"
    :placeholder="$t('type-to-search-presenters')"
    :filterable="false"
    @search="searchPresentersEvent"
    @input="presenterInputEvent"
  >
    <template slot="no-options">
      {{ searchInputText.length > 0 ? $t('network.noPresenters') : $t('network.startTypingPresenter') }}
    </template>

    <template #selected-option="{ user }">
      <div class="selected d-center">
        {{ user.first_name + ' ' + user.last_name }}
      </div>
    </template>

    <template #option="{ user, media_count }">
      <div class="d-center">
        {{ user.first_name + ' ' + user.last_name }}
      </div>
    </template>
  </v-select>
</template>
<script>
import debounce from 'lodash/debounce';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
    networkSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      presenter: null,
      presenters: [],
      searchInputText: '',
    };
  },
  methods: {
    searchPresentersEvent: function (search, loading) {
      this.searchInputText = search;
      if (search.length == 0) return;
      loading(true);
      this.searchPresentersRequest(loading, search, this);
    },
    searchPresentersRequest: debounce(function (loading, search, vm) {
      let url = 'courses/course/list/presenters?query=' + search;

      this.$http.get(url).then(resp => {
        vm.presenters = resp.data;
        loading(false);
      });
    }, 600),
    presenterInputEvent(option) {
      this.$emit('input', option);
    },
  },
};
</script>
<style>
.vs__dropdown-option {
  white-space: normal !important;
}
.vs__selected-options {
  flex-wrap: wrap !important;
  padding: 0px 0px 3px 2px !important;
}
</style>
